import React from 'react';
import { Clock, FileText, Mail, Phone } from 'lucide-react';



const PendingApprovalMessage = () => {
  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6">
      <div className="flex items-start space-x-3 space-x-reverse">
        <Clock className="h-6 w-6 text-yellow-600 mt-1" />
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-yellow-800 mb-2">
            حسابك في انتظار الموافقة
          </h3>
          <div className="text-yellow-700 space-y-2">
            <p>
              شكراً لتسجيلك كمدرس في منصتنا. حسابك حالياً في انتظار موافقة مدير النظام.
            </p>
            
            <div className="bg-yellow-100 rounded-md p-4 mt-4">
              <h4 className="font-medium text-yellow-800 mb-2 flex items-center">
                <FileText className="h-4 w-4 ml-2" />
                ماذا يحدث الآن؟
              </h4>
              <ul className="text-sm text-yellow-700 space-y-1 list-disc list-inside">
                <li>سيقوم مدير النظام بمراجعة بياناتك</li>
                <li>التحقق من المؤهلات والخبرات</li>
                <li>الموافقة على المواد والصفوف المطلوبة</li>
                <li>ستصلك إشعار بالبريد الإلكتروني عند الموافقة</li>
              </ul>
            </div>

            <div className="bg-yellow-100 rounded-md p-4 mt-4">
              <h4 className="font-medium text-yellow-800 mb-2 flex items-center">
                <Mail className="h-4 w-4 ml-2" />
                مدة المراجعة
              </h4>
              <p className="text-sm text-yellow-700">
                عادةً تستغرق عملية المراجعة من 24-48 ساعة عمل. إذا لم تصلك إشعار خلال هذه المدة، يمكنك التواصل معنا.
              </p>
            </div>

            <div className="bg-yellow-100 rounded-md p-4 mt-4">
              <h4 className="font-medium text-yellow-800 mb-2 flex items-center">
                <Phone className="h-4 w-4 ml-2" />
                هل لديك استفسار؟
              </h4>
              <p className="text-sm text-yellow-700">
                يمكنك التواصل مع فريق الدعم عبر:
                <br />
                البريد: support@almanassa.com
                <br />
                الهاتف: +0201121880800
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalMessage;
